import type { FC } from 'react';

import { SkeletonLoading } from '@zen/DesignSystem';

const AnalyticsAccountSettingsLoadingSkeleton: FC = () => {
  return (
    <div className="px-10 pt-6" data-testid="analytics-account-settings-loading-skeleton">
      <div className="flex -mx-2">
        <SkeletonLoading height={56} width="w-14" />
        <SkeletonLoading height={56} width="w-14" />
      </div>
    </div>
  );
};

export default AnalyticsAccountSettingsLoadingSkeleton;
